import { render, staticRenderFns } from "./NoFootLayout.vue?vue&type=template&id=bb41f8a6&"
import script from "./NoFootLayout.vue?vue&type=script&lang=js&"
export * from "./NoFootLayout.vue?vue&type=script&lang=js&"
import style0 from "./NoFootLayout.vue?vue&type=style&index=0&id=bb41f8a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports